import apiService from './apiService';

export const usersService = {
  async getUserById(id: string): Promise<any> {
    return apiService.get(`/users/${id}`);
  },

  async updateProfile(id: string, updates: any): Promise<any> {
    return apiService.put(`/users/${id}`, updates);
  },

  async getSettings(id: string): Promise<any> {
    return apiService.get(`/users/${id}/settings`);
  },

  async updateSettings(id: string, settings: any): Promise<any> {
    return apiService.put(`/users/${id}/settings`, settings);
  },

  async getPreferences(id: string): Promise<any> {
    return apiService.get(`/users/${id}/preferences`);
  },

  async updatePreferences(id: string, preferences: any): Promise<any> {
    return apiService.put(`/users/${id}/preferences`, preferences);
  },

  async getProgress(id: string): Promise<any> {
    return apiService.get(`/users/${id}/progress`);
  },

  async updateProgress(id: string, progress: any): Promise<any> {
    return apiService.put(`/users/${id}/progress`, progress);
  },
};
